const serviceCategory = Object.freeze({
  toCustomize: 1,
  toRepair: 2,
  toReplaceForTheft: 3,
  forTechAssistance: 4,
  forTrainning: 5,
  toReplaceForLost: 6,
});

export default serviceCategory;
